// CANONICAL COPY (GH #7115). src/constants/obligations/obl-security-objectives.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-security-objectives',
  title: 'Review information security objectives',
  description:
    'Confirm that information security objectives are established at relevant functions and levels, are consistent with the security policy, are measurable where practicable, and are monitored and updated.',
  category: 'risk',
  scfIds: ['SCF-RSK-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Information security objectives document is published',
    },
    { type: 'document-within-sla', description: 'Objectives review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
